export default __webpack_public_path__ + "static/media/logo-facebook.7fce0fac.png";